import Vue from 'vue'
import { initCore } from 'src/lib/init.js'
import { initItemPage } from 'src/lib/item-page'
import DatasetDistributionsDisplay from 'src/components/dataset/pages/DatasetDistributionsDisplay.vue'
import 'src/styles/aristotle.files.less'

initCore()
initItemPage()

new Vue({
    el: '#vue-ddg-display',
    components: {
        'dataset-distributions-display': DatasetDistributionsDisplay
    }
})
// Need to re-init drop downs
$('.dropdown-toggle').dropdown()
